import { render, staticRenderFns } from "./AmFormLayout.vue?vue&type=template&id=1270dc68&"
import script from "./AmFormLayout.vue?vue&type=script&lang=js&"
export * from "./AmFormLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports